import { render, staticRenderFns } from "./InstrumentDetails.vue?vue&type=template&id=4ab9bde5&scoped=true"
import script from "./InstrumentDetails.vue?vue&type=script&lang=ts"
export * from "./InstrumentDetails.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentDetails.vue?vue&type=style&index=0&id=4ab9bde5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9bde5",
  null
  
)

export default component.exports